"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelDashboard = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Dashboard_1 = require("../../../../components/Dashboard");
class PanelDashboard extends React.Component {
    render() {
        const { headerText, showConfigureButton, showCloseButton, onConfigure, onClose, accessLevel, children, } = this.props;
        return (React.createElement(Dashboard_1.DashboardToolbar, { title: headerText, onConfigure: onConfigure, showConfigure: showConfigureButton, showClose: showCloseButton, onClose: onClose, accessLevel: accessLevel }, children));
    }
}
exports.PanelDashboard = PanelDashboard;
PanelDashboard.defaultProps = {
    showConfigureButton: true,
    showCloseButton: true,
    headerText: 'Module',
    onClose: null,
    onConfigure: null,
    accessLevel: 'Full',
};
